import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  toggleSetting(event) {
    const switchEl = event.currentTarget;

    const checkboxId = switchEl.id.replace('_switch', '');
    const checkbox = document.getElementById(checkboxId);
    const targetSelector = switchEl.dataset.toggleSelector

    if (targetSelector) {
      const targetElement = this.element.querySelector(targetSelector)
      if (targetElement) {
        targetElement.style.display = checkbox.checked ? 'block' : 'none'
      }
    }
  }
}
